import { useMemo, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import AdminLayout from "@/components/admin/AdminLayout";
import CustomersTab from "@/components/admin/tabs/CustomersTab";
import TeamTab from "@/components/admin/tabs/TeamTab";
import CustomerVoiceTab from "@/components/admin/tabs/CustomerVoiceTab";
import RevenueTab from "@/components/admin/tabs/RevenueTab";
import BillingTab from "@/components/admin/tabs/BillingTab";
import OperationsTab from "@/components/admin/tabs/OperationsTab";
import PulseTab from "@/components/admin/tabs/PulseTab";
import usePageTitle from "@/hooks/usePageTitle";

const VALID_TABS = new Set(["pulse", "customers", "team", "customer-voice", "revenue", "billing", "ops"]);
const TAB_ALIASES = { users: "customers" };

export default function HqCommandUsers() {
  usePageTitle("pageTitles.adminUsers");
  const location = useLocation();
  const refreshRef = useRef(null);
  const [refreshing, setRefreshing] = useState(false);

  const activeTab = useMemo(() => {
    const params = new URLSearchParams(location.search);
    const raw = params.get("tab");
    const resolved = TAB_ALIASES[raw] || raw;
    return VALID_TABS.has(resolved) ? resolved : "pulse";
  }, [location.search]);

  const registerRefresh = (getter) => { refreshRef.current = getter; };

  const handleRefresh = async () => {
    if (!refreshRef.current) return;
    const fn = refreshRef.current();
    if (typeof fn !== "function") return;
    setRefreshing(true);
    try { await fn(); } finally { setRefreshing(false); }
  };

  return (
    <AdminLayout activeTab={activeTab} onRefresh={handleRefresh} refreshing={refreshing}>
      {({ me }) => {
        if (activeTab === "pulse")           return <PulseTab me={me} registerRefresh={registerRefresh} />;
        if (activeTab === "team")            return <TeamTab me={me} registerRefresh={registerRefresh} />;
        if (activeTab === "customer-voice")  return <CustomerVoiceTab me={me} registerRefresh={registerRefresh} />;
        if (activeTab === "revenue")         return <RevenueTab registerRefresh={registerRefresh} />;
        if (activeTab === "billing")         return <BillingTab registerRefresh={registerRefresh} />;
        if (activeTab === "ops")             return <OperationsTab registerRefresh={registerRefresh} />;
        if (activeTab === "customers")       return <CustomersTab me={me} registerRefresh={registerRefresh} />;
        return <PulseTab me={me} registerRefresh={registerRefresh} />;
      }}
    </AdminLayout>
  );
}
